<template>
  <div
    class="message-reaction"
    data-testid="reaction-icon"
    @click="handleClick"
  >
    <WIcon
      icon="icReactionSmile"
      size="medium"
      class="message-reaction__icon"
    />
  </div>
</template>
<script>
import { WIcon } from '@alice-health/wonderland-vue'

export default {
  components: {
    WIcon
  },
  emits: ['click'],
  methods: {
    handleClick() {
      this.$emit('click')
    }
  }
}
</script>
<style lang="scss" scoped>
.message-reaction {
  color: var(--gl-color-shades-gray-100);
  width: 32px;
  height: 32px;
  background: var(--gl-color-shades-gray-10);
  border: var(--gl-border-width-xs) solid var(--gl-color-shades-gray-10);
  border-radius: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: var(--gl-spacing-02);
  cursor: pointer;

  &__icon {
    display: flex;
    width: 16px;
  }
}
</style>
